import { toast } from "react-toastify";
import defaultErrorHandler from "actions/global/default-error-handler";

import {
  // requestSingle,
  requestAdd,
} from "./requests";

import {
  PHONE_CODES_LOADING,
  PHONE_CODES_ERROR,
  PHONE_CODES_LIST,
  PHONE_CODES_FILTERS,
  PHONE_CODES_CREATE,
  // PHONE_CODES_UPDATE,
  // PHONE_CODES_DELETE
} from "./constants";
import { requestCommonFilters, requestCommonSearch } from "../common/requests";

export const setLoading = (status) => ({
  type: PHONE_CODES_LOADING,
  payload: status
});

export const getFilters = () => dispatch => {
  dispatch(setLoading(true));
  requestCommonFilters("phone-codes")
    .then(response => {
      dispatch({
        type: PHONE_CODES_FILTERS,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, PHONE_CODES_ERROR));
    });
};

export const getList = (page = 0, size = 20, sort = "id,asc", filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch("phone-code", page, size, sort, filters)
    .then((response) => {
      dispatch({
        type: PHONE_CODES_LIST,
        payload: response
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, PHONE_CODES_ERROR));
    });
};

export const create = (data, callback) => dispatch => {
  requestAdd(data)
    .then(response => {
      dispatch({
        type: PHONE_CODES_CREATE,
        payload: response.data
      });
      toast(`Tag ${data.id ? "updated" : "created"} successfully`, {
        type: toast.TYPE.SUCCESS,
      });
      callback(true);
    })
    .catch(error => {
      dispatch(setLoading(false));
      dispatch(defaultErrorHandler(error, PHONE_CODES_ERROR));
    });
};



// WEBPACK FOOTER //
// ./src/actions/phone-codes/actions.js